import React from "react";
import { IRemarks } from "../../../../../../../../../../@types/remarks.types";

const RemarksCard = ({ remark, index }: { remark: IRemarks; index: number }) => {
	return (
		<div className="remarks_card">
			<p style={{ fontWeight: "bold" }}>CHARGE LINE {index + 1}</p>
			<div className="inline-flex">
				{remark.EXPLCD01 === 0 ? null : (
					<div className="inline-flex">
						<p style={{ marginRight: 10 }}>{remark.EXPLCD01}</p>
						<p>{remark.DESCR1}</p>
					</div>
				)}
				{remark.EXPLCD02 === 0 ? null : (
					<div className="inline-flex">
						<p style={{ marginRight: 10 }}>{remark.EXPLCD02}</p>
						<p>{remark.DESCR2}</p>
					</div>
				)}
				{remark.EXPLCD03 === 0 ? null : (
					<div className="inline-flex">
						<p style={{ marginRight: 10 }}>{remark.EXPLCD03}</p>
						<p>{remark.DESCR3}</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default RemarksCard;
